<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="equipment.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="equipment"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="资产编号" prop="propertyNo">
          <el-input v-model="equipment.propertyNo" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="设备编号" prop="no">
          <el-input v-model="equipment.no" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="equipment.name" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="型号" prop="model">
          <el-input v-model="equipment.model" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="位置">
          <el-input v-model="equipment.location" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="销售方">
          <el-input v-model="equipment.dealer" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="购入日期">
          <el-date-picker
              v-model="equipment.purchaseDate"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="维护周期" prop="maintenanceCycle">
          <el-input-number v-model="equipment.maintenanceCycle" :min="0" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="关键设备">
          <el-radio-group v-model="equipment.keyEquipment">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="equipment.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

  export default {
    name:"EquipmentEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        equipment: {
          pkid: 0,
          propertyNo: "",
          no: "",
          name: "",
          model: "",
          location: "",
          dealer: "",
          purchaseDate: "",
          maintenanceCycle: "",
          keyEquipment: false,
          note: "",
          isDeleted: 0,
        },
        ruleValidate: {
          propertyNo: {required: true, message: "不能为空",trigger: "blur"},
          no: {required: true, message: "不能为空",trigger: "blur"},
          name: {required: true, message: "不能为空",trigger: "blur"},
          model: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.equipment.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `equipments/${this.equipment.pkid}`)
          .then(resp => {
            console.log(resp);
            this.equipment = resp;
          });
      },
      handleSubmit() {
        if(this.equipment.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "equipments",  this.equipment)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "equipments", this.equipment)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
